var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "hello"
  }, [_c('div', {
    staticClass: "handle-wrapper"
  }, [_c('Input', {
    staticStyle: {
      "width": "250px",
      "margin-right": "auto"
    },
    attrs: {
      "search": "",
      "placeholder": "搜索客户...",
      "clearable": "",
      "icon": "ios-search"
    },
    on: {
      "on-change": _vm.searchMaterial
    },
    model: {
      value: _vm.searchText,
      callback: function ($$v) {
        _vm.searchText = $$v;
      },
      expression: "searchText"
    }
  }), _c('span', [_vm._v("共" + _vm._s(_vm.totalRows) + "条")]), _c('Page', {
    staticStyle: {
      "margin-right": "24px"
    },
    attrs: {
      "total": _vm.totalRows,
      "page-size": 15,
      "show-total": "",
      "simple": ""
    },
    on: {
      "on-change": _vm.loadMaterial
    }
  }), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.openCreateSalesRecordDrawer();
      }
    }
  }, [_vm._v("新增销售记录")])], 1), _c('div', {
    ref: "tableWrapper",
    staticClass: "table-wrapper"
  }, [_c('Table', {
    attrs: {
      "loading": _vm.tableLoading,
      "columns": _vm.columns,
      "data": _vm.tableData,
      "height": _vm.tableHeight
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function (_ref) {
        var row = _ref.row;
        return [_c('Poptip', {
          attrs: {
            "placement": "bottom",
            "word-wrap": "",
            "width": "400",
            "trigger": "hover",
            "content": row.content
          }
        }, [_c('p', {
          staticClass: "content-item"
        }, [_vm._v(_vm._s(row.content))])])];
      }
    }])
  })], 1), _c('CreateSalesRecordDrawer', {
    ref: "CreateSalesRecordDrawer"
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }